import type { RouteObject } from "react-router-dom";
import { Outlet } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Bodegas from "../pages/bodegas/page";
import BodegaDetalle from "../pages/bodegas/detalle/page";
import Planes from "../pages/planes/page";
import Ubicacion from "../pages/ubicacion/page";
import Seguridad from "../pages/seguridad/page";
import Nosotros from "../pages/nosotros/page";
import PreguntasFrecuentes from "../pages/preguntas-frecuentes/page";
import Contacto from "../pages/contacto/page";
import Terminos from "../pages/terminos/page";
import Privacidad from "../pages/privacidad/page";
import { AdminSessionProvider } from "@/admin/AdminSessionContext";
import ProtectedRoute from "@/admin/ProtectedRoute";
import AdminLogin from "@/admin/pages/Login";
import AdminDashboard from "@/admin/pages/Dashboard";
import AdminSettings from "@/admin/pages/Settings";
import AdminUsers from "@/admin/pages/Users";
import AdminMedia from "@/admin/pages/Media";
import AdminBodegas from "@/admin/pages/Bodegas";
import AdminPlanes from "@/admin/pages/Planes";
import AdminFaqs from "@/admin/pages/Faqs";
import AdminTestimonios from "@/admin/pages/Testimonios";
import AdminContentBlocks from "@/admin/pages/ContentBlocks";
import AdminPages from "@/admin/pages/Pages";
import AdminLeads from "@/admin/pages/Leads";
import AdminGoogleDrive from "@/admin/pages/GoogleDrive";
import AdminSiteStatus from "@/admin/pages/SiteStatus";
import AdminBannerPrincipal from "@/admin/pages/BannerPrincipal";
import AdminContactForm from "@/admin/pages/ContactForm";
import AdminCorreoFormulario from "@/admin/pages/CorreoFormulario";
import AdminHomeRecinto from "@/admin/pages/HomeRecinto";
import AdminSiteTexts from "@/admin/pages/SiteTexts";

function AdminRoot() {
  return (
    <AdminSessionProvider>
      <Outlet />
    </AdminSessionProvider>
  );
}

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/bodegas", element: <Bodegas /> },
  { path: "/bodegas/:id", element: <BodegaDetalle /> },
  { path: "/planes", element: <Planes /> },
  { path: "/ubicacion", element: <Ubicacion /> },
  { path: "/seguridad", element: <Seguridad /> },
  { path: "/nosotros", element: <Nosotros /> },
  { path: "/preguntas-frecuentes", element: <PreguntasFrecuentes /> },
  { path: "/contacto", element: <Contacto /> },
  { path: "/terminos", element: <Terminos /> },
  { path: "/privacidad", element: <Privacidad /> },
  {
    path: "/admin",
    element: <AdminRoot />,
    children: [
      { index: true, element: <ProtectedRoute><AdminDashboard /></ProtectedRoute> },
      { path: "login", element: <AdminLogin /> },
      { path: "settings", element: <ProtectedRoute><AdminSettings /></ProtectedRoute> },
      { path: "estado", element: <ProtectedRoute><AdminSiteStatus /></ProtectedRoute> },
      { path: "banner", element: <ProtectedRoute><AdminBannerPrincipal /></ProtectedRoute> },
      { path: "recinto", element: <ProtectedRoute><AdminHomeRecinto /></ProtectedRoute> },
      { path: "textos", element: <ProtectedRoute><AdminSiteTexts /></ProtectedRoute> },
      { path: "google-drive", element: <ProtectedRoute><AdminGoogleDrive /></ProtectedRoute> },
      { path: "bodegas", element: <ProtectedRoute><AdminBodegas /></ProtectedRoute> },
      { path: "planes", element: <ProtectedRoute><AdminPlanes /></ProtectedRoute> },
      { path: "faqs", element: <ProtectedRoute><AdminFaqs /></ProtectedRoute> },
      { path: "testimonios", element: <ProtectedRoute><AdminTestimonios /></ProtectedRoute> },
      { path: "bloques", element: <ProtectedRoute><AdminContentBlocks /></ProtectedRoute> },
      { path: "paginas", element: <ProtectedRoute><AdminPages /></ProtectedRoute> },
      { path: "contactos", element: <ProtectedRoute><AdminLeads /></ProtectedRoute> },
      { path: "formulario", element: <ProtectedRoute><AdminContactForm /></ProtectedRoute> },
      { path: "correo", element: <ProtectedRoute><AdminCorreoFormulario /></ProtectedRoute> },
      { path: "usuarios", element: <ProtectedRoute><AdminUsers /></ProtectedRoute> },
      { path: "medios", element: <ProtectedRoute><AdminMedia /></ProtectedRoute> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
